import React from "react";
import PropTypes from "prop-types";

const CustomLegend = ({ currentTab = "" }) => {
  if (currentTab === "keyNumbers") {
    return (
      <div className="custom-legend">
        <div><span className="legend-square square-wd"/><span>Countries with WaterData profile</span></div>
        <div><span className="legend-square square-snapshot"/><span>Countries with snapshot</span></div>
      </div>
    );
  } else if(currentTab === "tariffs") {
    return (
      <div className="custom-legend tariffs">
        <div><span className="legend-square square-one"/><span>&lt;$0.49/m<sup>3</sup></span></div>
        <div><span className="legend-square square-two"/><span>$0.50-0.99/m<sup>3</sup></span></div>
        <div><span className="legend-square square-three"/><span>$1.00-1.99/m<sup>3</sup></span></div>
        <div><span className="legend-square square-four"/><span>&gt;$2.00/m<sup>3</sup></span></div>
      </div>
    );
  }
  return null;
};

export default CustomLegend;

CustomLegend.propTypes = {
  currentTab: PropTypes.string,
};
